import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const actionButtonVariants = cva(
  "inline-flex items-center justify-center gap-4 whitespace-nowrap rounded-[1.25rem] text-base font-semibold ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 min-h-[44px]",
  {
    variants: {
      variant: {
        default:
          "shadow-button hover:shadow-hover hover:-translate-y-0.5 active:translate-y-0 focus:ring-2 focus:ring-primary",
        secondary:
          "shadow-button hover:shadow-hover hover:-translate-y-0.5 active:translate-y-0 focus:ring-2 focus:ring-secondary",
        outline:
          "shadow-soft hover:shadow-button hover:-translate-y-0.5 hover:scale-[1.01] active:translate-y-0 active:scale-100 focus:ring-2 focus:ring-accent",
        ghost:
          "shadow-soft hover:shadow-button hover:-translate-y-0.5 active:translate-y-0 focus:ring-2 focus:ring-primary",
      },
      size: {
        default: "h-20 px-6 py-5",
        sm: "h-16 px-6 py-4 text-sm",
        lg: "h-24 px-8 py-6 text-lg",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface ActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof actionButtonVariants> {
  asChild?: boolean;
}

const ActionButton = React.forwardRef<HTMLButtonElement, ActionButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    return (
      <button
        className={cn(actionButtonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
ActionButton.displayName = "ActionButton";

export { ActionButton, actionButtonVariants };